import { Component, HostListener, OnInit, Renderer2 } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TestService } from 'src/app/services/test.service';
import { CommonsService } from 'src/app/services/commons.service';
import { Router } from '@angular/router';


@Component({
  standalone: false,
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss'],
  animations: [
    trigger('fade', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate(1300, style({ opacity: 1 }))
      ])
    ])
  ]
})
export class TestComponent implements OnInit {

  testValue: any;
  form: UntypedFormGroup;
  data: any;
  tests: Array<any>;
  showProgress = false;
  isRapidScore = false;
  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly testService: TestService,
    private readonly c: CommonsService,
    private readonly route: Router
  ) {

  }

  ngOnInit() {
    this.isRapidScore = !!JSON.parse(sessionStorage.getItem('getParams'));
    this.data = JSON.parse(sessionStorage.getItem('testValue'));
    this.tests = this.data.testList;
    this.form = this.formBuilder.group({
      idTest: new UntypedFormControl(this.tests[0].idTest, []),
      document: new UntypedFormControl('', []),
      name: new UntypedFormControl('', []),
      surname1: new UntypedFormControl('', []),
      surname2: new UntypedFormControl('', [])
    });
  }

  getDescription() {
    const obj = this.tests.find(value => value.idTest == this.form.controls.idTest.value);
    return obj.description;
  }

  onSubmit() {
    this.showProgress = true;
    this.testService.postTest(this.form.value).subscribe((d) => {
      this.showProgress = false
      if (d.Code === 401) {
        //401
        return;
      } else if (d.Code === 409) {
        // 409
        return;
      } else if (d.Code === 403) {
        return;
      }
      this.route.navigateByUrl('engagement');
      sessionStorage.setItem('t', d.Token);
      sessionStorage.setItem('_k', this.c.encrypt(d));
      this.c.setKpi(d);
    }, (err) => this.showProgress = false);
  }

}